const getIsOk = state => state.isOK;

export default {
  getIsOk,
};
